import styled from 'styled-components';

export const Box = styled.div`
  background-color: #ffc;
  text-align: center;
  padding: 1.5rem;
`
export const Alert = styled.p`
  color: #ff0000;
  font-size: .78rem;
  margin: 0;
  font-weight: 500;
`
